import React from 'react';

const VARIANT_COPY = {
  general:
    'Some recommendations, insights, summaries, or suggestions provided by Liaizn may be generated or assisted by artificial intelligence. While we aim to provide useful and relevant information, AI-generated content may contain inaccuracies, omissions, or outdated information. Please use the information as a guide and apply your own judgement before making important academic, career, employment, or professional decisions.',
  assessment:
    'AI Insight: This insight is generated using available assessment and profile information and is intended to help you understand potential strengths and areas for improvement. It should not be treated as a definitive evaluation of your abilities.',
  career:
    'Important: Career suggestions provided by AI are intended for guidance only. They should not be considered a guarantee of employment, career outcomes, or suitability for a particular role.',
  jobs:
    'AI-Powered Recommendation: Job recommendations are generated based on the information available in your profile and may not always reflect the complete requirements or current status of a role. Please verify the opportunity details before applying.',
};

const AiDisclaimer = ({ variant = 'general' }) => {
  const text = VARIANT_COPY[variant] || VARIANT_COPY.general;
  return (
    <p className="text-xs text-gray-500 leading-relaxed border border-gray-200 bg-gray-50 rounded-lg px-3 py-2">
      {text}
    </p>
  );
};

export default AiDisclaimer;
